import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import getters from './getters'
import user from './modules/user'
import home from './modules/home'
import cost from './modules/cost'
import receipt from './modules/receipt'

const LegacyPersistedStateKey = 'vuex'
const PersistedStateKey = 'school-mobile-v2'

function migratePersistedState() {
  if (typeof window === 'undefined') return

  let storage
  try {
    storage = window.localStorage
    const legacyState = storage.getItem(LegacyPersistedStateKey)
    if (legacyState && !storage.getItem(PersistedStateKey)) {
      const parsedState = JSON.parse(legacyState)
      if (parsedState?.home) {
        storage.setItem(
          PersistedStateKey,
          JSON.stringify({ home: parsedState.home })
        )
      }
    }
  } catch {
    // 无法解析的旧数据不应阻塞应用启动。
  } finally {
    if (storage) {
      try {
        storage.removeItem(LegacyPersistedStateKey)
      } catch {
        // 浏览器禁用 localStorage 时交由持久化插件按原有行为处理。
      }
    }
  }
}

migratePersistedState()

const store = createStore({
  // 费用数据具有时效性，不能持久化到 localStorage。
  // 使用新 key 避免升级后再次恢复旧版保存在 `vuex` 中的费用项目。
  plugins: [
    createPersistedState({
      key: PersistedStateKey,
      // 保留现有的学校/学生跳转上下文，但不保存 cost、receipt 等业务数据。
      paths: ['home'],
    }),
  ],
  modules: {
    user,
    home,
    cost,
    receipt,
  },
  getters,
})

export default store
